/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/


import React from 'react';


const TaperedRule: React.FC = () => (
  <svg height="5" width="100%" className="tapered-rule">
    <polyline points="0,0 400,2.5 0,5" />
  </svg>
);

export default TaperedRule;
